import { useQuery } from '@tanstack/react-query';

import {
  getContentfulReasonsToSwitch,
  getContentfulStressFreeSwitching,
  getContentfulFAQ,
  getContentfulBottomAwards,
  getContentfulErrorPage,
  getContentfulPageAssetBySlug,
  getContentfulButtonTextBySlug,
} from '~/queries/getContentful';

export const useContentfulReasonsToSwitch = () => {
  return useQuery(getContentfulReasonsToSwitch);
};

export const useContentfulStressFreeSwitching = () => {
  return useQuery(getContentfulStressFreeSwitching);
};

export const useContentfulFAQ = () => {
  return useQuery(getContentfulFAQ);
};

export const useContentfulBottomAwards = () => {
  return useQuery(getContentfulBottomAwards);
};

export const useContentfulErrorPage = () => {
  return useQuery(getContentfulErrorPage);
};

export const useContentfulPageAssetBySlug = (slug: string) => {
  return useQuery(getContentfulPageAssetBySlug(slug));
};

export const useGetContentfulButtonTextBySlug = (slug: string) => {
  return useQuery(getContentfulButtonTextBySlug(slug));
};
